import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

new Vue({
  router,
  store,
  sockets: {},
  render: h => h(App)
}).$mount('#app');
